import React, { useEffect, useState } from 'react'
import Delete from '../../../Components/Icons/Delete';
import { Link, useParams } from 'react-router-dom';
import Edit from '../../../Components/Icons/Edit';
import View from '../../../Components/Icons/View';
import DataTable from '../../../Components/Layouts/DataTable';
import { CreateButton } from '../../../Components/Utils/Buttons';
import SearchBar from '../../../Components/Utils/SearchBar';
import BreadCrumb from '../../../Components/Utils/Breadcrumbs';
import axiosInstance from '../../../Services/axiosCommon';

function CreateNotesindex() {
  const {officeId} =useParams();
  const [data, setData] = useState([]);
  async function getCreditNotes() {
    const params = {
      page:1,
      per_page:20,
    };
    await axiosInstance
      .get(`/credit_note/`,{ params })
      .then(async (res) => {
        console.log(res.data.data.cashDetails)
        res?.data?.data && setData(res?.data?.data.creditDetails
          );
        // setTotalSubs(res.data?.totalRecords);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  let headers = [
    {
      label: <span>ID</span>,
      width: "w-[7%]",
    },
    {
      label: <span>Invoice #</span>,
      width: "w-[10%]",
    },
    {
      label: <span>Tax Amount</span>,
      width: "w-[15%]",
    },
    {
      label: <span>Amount</span>,
      width: "w-[10%]",
    },
    {
      label: <span>Total Amount</span>,
      width: "w-[10%]",
    },
    {
      label: <span>Requested by</span>,
      width: "w-[10%]",
    },
   
    {
      label: <span>Status</span>,
      width: "w-[10%]",
    },
    {
      label: <span>Action</span>,
      width: "w-[10%]",
    },
  ];
  useEffect(()=>{
    getCreditNotes();
  },[]);
  return (
    <div className="w-full h-full px-4 py-2">
      <div className="w-full h-[46px]  flex justify-between ">
        <BreadCrumb
          items={[
            { title: <p className=" text-[12px] ">Test</p> },
            { title: <p className=" text-[12px] ">Credit-Notes</p> },
          ]}
        />
        <div className=" flex gap-2">
          <SearchBar />
          <CreateButton label="Import" />
          <Link to="/main/credit-notes/${officeId}/create">
            <CreateButton label="Credit-Notes" />
          </Link>
        </div>
      </div>

      <DataTable
        headers={headers}
        total={100}
        pageIndex={1}
        setPageIndex={() => {}}
        dataCount={20}
        setDataCount={() => {}}
      >
        {data?.length > 0 ? (
          data.map((item, i) => {
            return (
              <tr
                className=" p-1 hover:scale-y-105 rounded-l-md hover:shadow-md"
                key={i}
              >
                <td className="w-[7%] py-3 my-6 text-center bg-white rounded-l-md ">
                  {"#"+item?.credit_noteId || "#"}
                </td>
                <td className="w-[10%] p-2 text-center bg-white">
                  {item?.invoiceOutId || ""}
                </td>
                <td className="w-[15%] p-2 text-center bg-white">
                  {item?.taxAmount|| "-"}
                </td>
                <td className="w-[10%] p-2 text-center bg-white">
                  {item?.amount || ""}
                </td>
                {/* <td className="w-[15%] p-2 text-right ">test</td> */}
                <td className="w-[10%] p-2  text-center bg-white">
                  {item?.totalAmount || 0}
                </td>
                <td className="w-[10%] p-2  text-center bg-white">
                  {item?.reasonForCreditNote || 0}
                </td>
                <td className="w-[10%] p-2  text-center bg-white">
                  {item?.status || 0}
                </td>
              
                <td className="w-[10%] p-2 text-center bg-white rounded-r-md">
                  <div className=" w-full flex justify-center items-center gap-2">
                    <Link to={`/main/credit-notes//${officeId}view/${item?.credit_noteId}`}>
                      <View />
                    </Link>
                    <Link to={`/main/credit-notes//${officeId}edit/${item?.credit_noteId}`}>
                      <Edit />
                    </Link>
                    <Link>
                      <Delete />
                    </Link>
                  </div>
                </td>
              </tr>
            );
          })
        ) : (
          <tr className=" text-center my-2 font-semibold text-sm">
            <div className=" w-full h-[calc(100vh-240px)] rounded-md flex justify-center items-center bg-slate-300">
            No Data Found
            </div>
          </tr>
        )}
      </DataTable>
    </div>
  );
}

export default CreateNotesindex;